export enum PolicyNumberType {
    PERSON = 'person',
    COMPANY = 'company',
    FOREIGNER = 'foreigner',
    INSIS9 = 'insis9',
    INSIS10 = 'insis10',
    MTPL = 'mtpl',
}
